'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = QuestionMarkSquared;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function QuestionMarkSquared(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-question-mark-squared ' + className,
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement(
      'g',
      { fill: color, fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M14 0c.542 0 1.01.198 1.406.594C15.802.99 16 1.458 16 2v9c0 .542-.198 1.01-.594 1.406A1.922 1.922 0 0 1 14 13H9.5l-3.906 2.937a.414.414 0 0 1-.235.063.344.344 0 0 1-.25-.11.362.362 0 0 1-.109-.265V13H2c-.542 0-1.01-.198-1.406-.594A1.922 1.922 0 0 1 0 11V2C0 1.458.198.99.594.594A1.922 1.922 0 0 1 2 0h12zm.5 11V2a.487.487 0 0 0-.14-.36.487.487 0 0 0-.36-.14H2a.487.487 0 0 0-.36.14.487.487 0 0 0-.14.36v9c0 .146.047.266.14.36.094.093.214.14.36.14h4.5v1.875L9 11.5h5a.487.487 0 0 0 .36-.14.487.487 0 0 0 .14-.36z' }),
      _react2.default.createElement('path', { d: 'M10.44 5.09c0 .423-.124.784-.375 1.081-.156.172-.415.36-.775.564-.188.11-.313.196-.376.258-.11.079-.164.173-.164.282v.141a.272.272 0 0 1-.083.2.272.272 0 0 1-.2.082h-1.08a.272.272 0 0 1-.2-.082.272.272 0 0 1-.082-.2v-.211c0-.36.126-.666.376-.916.141-.141.376-.306.705-.494l.047-.023c.235-.141.4-.25.493-.329a.517.517 0 0 0 .165-.376c0-.188-.098-.344-.294-.47a1.194 1.194 0 0 0-.658-.188c-.242 0-.45.055-.622.165-.141.094-.313.274-.517.54a.35.35 0 0 1-.176.094.235.235 0 0 1-.2-.047l-.658-.493a.257.257 0 0 1-.105-.188.38.38 0 0 1 .035-.212c.298-.422.634-.74 1.01-.95.376-.212.83-.318 1.362-.318.376 0 .752.094 1.128.282.376.188.677.438.904.752.227.313.34.665.34 1.057zM8.915 9.014a.948.948 0 0 1-.294.693.948.948 0 0 1-.692.294.948.948 0 0 1-.693-.294.948.948 0 0 1-.294-.693c0-.266.098-.497.294-.693a.948.948 0 0 1 .693-.293c.266 0 .497.098.692.293a.948.948 0 0 1 .294.693z' })
    )
  );
}

QuestionMarkSquared.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/QuestionMarkSquared/QuestionMarkSquared.js
// module id = 1265
// module chunks = 1